import React from 'react';
import { motion } from 'framer-motion';
import faqBg from '../assets/faq.png'; 
import pmsImg from "../assets/pms1.png";
import banner2 from '../assets/banner2.png';
import {ShieldCheck, UserCheck,BarChart3} from 'lucide-react';
import kidBg from '../assets/bgcloud.png'; // Using your existing cloud background
import aifImg from '../assets/aif.png';
import aifTypes from '../assets/aif-types.png';
import aifReg from '../assets/aif-reg.png';
import keyFeaturesImg from '../assets/pmskey.png';
import { Briefcase } from "lucide-react";

const PMSAIF = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* SECTION 1: WHAT IT IS (Image Left, Text Right)  */}
      <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
 

   <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
         PMS / AIF
        </h3>

  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>



      

       <section className="relative pt-20 pb-20 overflow-hidden bg-white ">
        {/* Background Decor - Restored width for symmetry */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 -z-10 hidden lg:block" />

        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-15">
            
            {/* LEFT SIDE: CONTENT */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full lg:w-3/5" // Takes up 60% of the space
            >
            
            
              <div className="space-y-6 max-w-xl"> {/* Prevents text from leaking into the center */}
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                 Portfolio Management Services (PMS) offer investors a professionally managed, customized equity and debt portfolio. 
                </p>
                
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                  Unlike mutual funds, PMS accounts (stocks) are held in the investor’s name, providing higher transparency, flexibility, and personalized strategy aligned with your financial goals and risk profile.
                </p>

                <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
                 Portfolio Management Services (PMS) provide an elite investment framework where high-conviction strategies meet personalized direct ownership, ensuring your wealth is managed with surgical precision.
                </p>
              </div>
            </motion.div>

            {/* RIGHT SIDE: IMAGE */}
            <motion.div 
              className="w-full lg:w-2/5 flex justify-end" // Takes up 40% and pins to the right margin
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="relative w-full max-w-[380px] mt-5"> 
                <div className="overflow-hidden rounded-sm"> {/* Clean edge like Our Story */}
                  <img 
                    src={pmsImg} 
                    alt="Mutual Funds Overview" 
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* SECTION 1: HERO SECTION (Above the Fold) 
<section className="relative min-h-[700px] flex items-center overflow-hidden bg-slate-900">
  <div className="absolute inset-0 z-0">
    <img 
      src={pmsBg} 
      className="w-full h-full object-cover object-center opacity-60" 
      alt="DreamLadder Capital PMS and AIF investment services background"
    />
   
    <div 
      className="absolute inset-0" 
      style={{
        background: `linear-gradient(to right, 
          rgba(15, 23, 42, 0.95) 0%, 
          rgba(15, 23, 42, 0.8) 40%, 
          rgba(15, 23, 42, 0) 100%)`
      }}
    ></div>
  </div>

  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10 w-full">
    <div className="w-full lg:w-3/5">
        <h1 className="text-[28px] md:text-[48px] font-syne font-bold text-white leading-tight mb-6">
          Professionally Managed Portfolios, <br /> 
          <span className="text-red-600">Built Around You.</span>
        </h1>
        
        <div className="border-l-4 border-red-600 pl-6 mb-10">
          <p className="text-slate-300 text-base md:text-lg font-medium leading-relaxed max-w-xl">
            DreamLadder Capital offers SEBI-registered Portfolio Management Services (PMS) designed 
            to grow your wealth through personalized strategies and disciplined execution.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button className="bg-red-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-red-700 transition-all shadow-lg">
            Book a PMS Consultation
          </button>
          
          <button className="bg-white/10 backdrop-blur-md border border-white/20 text-white px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-all">
            Speak to a Relationship Manager
          </button>
        </div>
    </div>
  </div>
</section>
*/}


{/* SECTION 2: WHAT IS PMS? (High-End Professional UI) */}
{/* SECTION 2: UNDERSTANDING PMS (Bespoke/Robot Style) */}
{/*
<section className="py-24 bg-white">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    
    
    <div className="mb-16">
    
       <h3 className="text-[24px] md:text-[40px] text-slate-900  tracking-tight font-medium mb-6">
               Understanding Portfolio Management
              </h3>
      <div className="w-20 h-1 bg-red-600 mt-4"></div>
      <p className="text-slate-600 text-sm mt-6 max-w-2xl leading-relaxed">
        Portfolio Management Services (PMS) offer investors a professionally managed, customized equity and debt portfolio. Unlike mutual funds, PMS accounts (stocks) are held in the investor’s name, providing higher transparency, flexibility, and personalized strategy aligned with your financial goals and risk profile.
      </p>
    </div>

   
    <div className="rounded-3xl border border-slate-100 overflow-hidden shadow-sm">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        
       
        <div className="bg-slate-50/50 p-10 lg:p-16">
          <h3 className="text-xs font-black text-slate-400 uppercase tracking-[0.2em] mb-12">Mutual Funds</h3>
          <div className="space-y-12">
            <div>
              <h4 className="text-xl font-bold text-slate-400 mb-2">Indirect Ownership</h4>
              <p className="text-slate-500 text-sm leading-relaxed">Investors own units of a collective pool, with no direct legal claim to individual underlying securities.</p>
            </div>
            <div>
              <h4 className="text-xl font-bold text-slate-400 mb-2">Standardized Model</h4>
              <p className="text-slate-500 text-sm leading-relaxed">A one-size-fits-all strategy where every investor follows the same portfolio regardless of risk profile.</p>
            </div>
            <div>
              <h4 className="text-xl font-bold text-slate-400 mb-2">Pool-Based Flexibility</h4>
              <p className="text-slate-500 text-sm leading-relaxed">Limited control over entry and exit timing of specific stocks due to regulatory constraints on mass funds.</p>
            </div>
          </div>
        </div>

       
        <div className="bg-[#001f3f] p-10 lg:p-16 relative overflow-hidden">
         
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-600/10 blur-[100px]"></div>
          
          <h3 className="text-xs font-black text-red-700 uppercase tracking-[0.2em] mb-12">DreamLadder PMS</h3>
          <div className="space-y-12 relative z-10">
            <div>
              <h4 className="text-xl font-bold text-white mb-2 flex items-center gap-3">
                Direct Ownership 
              </h4>
              <p className="text-slate-300 text-sm leading-relaxed">Securities are held directly in <span className="text-white font-bold">your individual DP account</span>, giving you full transparency and voting rights.</p>
            </div>
            <div>
              <h4 className="text-xl font-bold text-white mb-2">Bespoke Customization</h4>
              <p className="text-slate-300 text-sm leading-relaxed">Portfolios are constructed <span className="text-white font-bold">specifically for you</span>, allowing for tax-efficient planning and custom sector weightages.</p>
            </div>
            <div>
              <h4 className="text-xl font-bold text-white mb-2">Concentrated Growth</h4>
              <p className="text-slate-300 text-sm leading-relaxed">Freedom to hold <span className="text-white font-bold">high-conviction positions</span> that aren't diluted by the mass-market mandates of mutual funds.</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    
  </div>
</section>
*/}
{/* SECTION 3: KEY FEATURES (Three-Column Layout) */}
{/* SECTION 3: KEY FEATURES (Three-Column Layout) */}


<section className="relative w-full py-20 md:py-28 bg-white overflow-hidden "
  style={{
    backgroundImage: `url(${kidBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }}>
  
  {/* Light overlay to maintain readability over kidBg */}
 

  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
      
      {/* LEFT SIDE: HEADING + IMAGE */}
      <div className="w-full lg:w-1/2 lg:sticky lg:top-12 pt-20">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-10 text-center lg:text-left"
        >
           <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-3">
          Key Features
        </h3>

      

        <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-12">
          AIFs in India operate under the SEBI (Alternative Investment Funds) Regulations, 2012, ensuring a sophisticated environment for private capital.
        </p>
        
        </motion.div>

       <motion.div 
  initial={{ opacity: 0, x: -20 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  className="flex justify-center lg:justify-start"
>
  <div className="w-full max-w-[530px] h-[160px]">
    <img 
      src={keyFeaturesImg} 
      alt="Operational Workflow" 
      className="w-full h-full object-cover object-bottom"
    />
  </div>
</motion.div>

      </div>

      {/* RIGHT SIDE: THE FEATURE CARDS (Content stays as it is) */}
      <div className="w-full lg:w-1/2 space-y-5">
        {[
          { 
            icon: <UserCheck size={22} />, 
            title: "Structured Mandate", 
            desc: "Each AIF operates under a defined investment objective and strategy as outlined in its scheme documents." 
          },
          { 
            icon: <BarChart3 size={22} />, 
            title: "Periodic Reporting", 
            desc: "Investors receive periodic updates and disclosures from the respective fund manager in accordance with regulatory requirements." 
          },
          { 
            icon: <Briefcase size={22} />, 
            title: "Professional Fund Management", 
            desc: "Investment decisions are undertaken by the designated fund manager in line with the fund’s stated mandate and regulatory framework." 
          },
           { 
            icon: <ShieldCheck size={22} />, 
            title: "Private Capital Access", 
            desc: "AIFs provide access to alternative investment opportunities such as private equity, venture capital, structured debt, or other specialized strategies." 
          }
        ].map((feature, idx) => (
          <motion.div 
            key={idx}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1 }}
            className="group flex items-start gap-5 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-red-100 transition-all duration-300"
          >
            <div className="flex-shrink-0 w-12 h-12 bg-red-50 text-red-600 rounded-xl flex items-center justify-center group-hover:bg-red-600 group-hover:text-white transition-colors duration-300">
              {feature.icon}
            </div>
            <div>
              <h4 className="text-lg font-bold text-slate-900 mb-1">{feature.title}</h4>
              <p className="text-slate-600 text-base md:text-lg font-medium">{feature.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>

    </div>
  </div></section>
   

{/* SECTION 4: SEBI REGULATIONS & ELIGIBILITY */}
{/* SECTION 4: SEBI REGULATIONS & ELIGIBILITY  text-slate-600 text-base leading-relaxed font-medium*/ }
<section className="pt-16 pb-24 bg-white relative overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
      
      {/* LEFT: Content & Elite Geometric Bullets */}
      <div>
        
         <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
                SEBI-Regulated Framework
              </h3> 

        {/* ELITE BULLET LIST - Red & Slate DNA 
         <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-12  ">
          PMS in India is governed by the <span className="text-slate-900 font-bold">SEBI (Portfolio Managers) Regulations, 2020</span>, ensuring transparency and investor protection through strict compliance standards.
        </p>
        */}
      {/* ELITE BULLET LIST - Red & Slate DNA */}
{/* ELITE BULLET LIST */}
<div className="flex flex-col">
  {[
    { title: "Minimum Investment", detail: "₹50 Lakh initial ticket size as per strictly mandated SEBI guidelines." },
    { title: "Separate Custody", detail: "Client assets are held securely in the investor’s individual demat and bank accounts." },
    { title: "Disclosure Norms", detail: "Managers must provide periodic performance reports and transparent expense disclosures." },
    { title: "Regulatory Registration", detail: "Every PMS provider is registered with SEBI and follows rigorous compliance audits." }
  ].map((item, idx, array) => (
    <div key={idx} className="flex gap-6 group">
      
      {/* LEFT COLUMN: Bullet + Auto-Stretching Line */}
      <div className="flex flex-col items-center">
        {/* Diamond Bullet */}
        <div className="w-2.5 h-2.5 bg-white border-2 border-red-600 rotate-45 group-hover:bg-red-600 transition-all duration-300 z-10 relative mt-[7px]"></div>
        
        {/* THE FIX: flex-grow makes this line exactly as tall as the text next to it */}
        {idx !== array.length - 1 && (
          <div className="flex-grow w-[1px] bg-slate-400 group-hover:bg-red-600/60 transition-colors my-2"></div>
        )}
      </div>
      
      {/* RIGHT COLUMN: Content with fixed padding-bottom for perfect spacing */}
      <div className={`${idx !== array.length - 1 ? 'pb-12' : 'pb-0'}`}>
         {/* <h4 className="text-[13px] font-black text-slate-900 uppercase tracking-widest mb-2 group-hover:text-red-600 transition-colors">
          {item.title}
        </h4> */}
        <h4 className="font-syne text-xl font-bold text-slate-900">
                  {item.title}
                </h4>
        <p className="text-slate-600 text-base md:text-lg font-medium ">
          {item.detail}
        </p>
      </div>
    </div>
  ))}
</div>
      </div>

      {/* RIGHT: The Seal-Style Badge - Red Accent 
      <div className="flex justify-center lg:justify-end"> */}
<div className="flex flex-col items-center lg:items-end">

  {/* ✅ ADD THIS ABOVE & OUTSIDE THE CARD */}
  <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mb-8 italic max-w-md mt-3">
    PMS in India is governed by the{" "}
    <span className="text-slate-900 font-bold">
      SEBI (Portfolio Managers) Regulations, 2020
    </span>
    , ensuring transparency and investor protection through strict compliance standards.
  </p>
        <div className="relative pt-6 pb-6 px-4 lg:pt-10 lg:pb-10 lg:px-8 bg-white rounded-[28px] shadow-2xl shadow-slate-200 border border-slate-100 flex flex-col items-center text-center max-w-sm mt-3">
          
          <div className="w-24 h-24 rounded-full border-4 border-slate-50 flex items-center justify-center mb-8 relative">
            {/* Spinning Dashed Circle: Now Red */}
            <div className="absolute inset-0 border-2 border-red-600 rounded-full border-dashed animate-[spin_20s_linear_infinite]"></div>
            
            {/* Shield Icon: Swapped stroke to Red */}
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/>
            </svg>
          </div>

          <h3 className="text-xl font-bold text-slate-900 mb-2 uppercase font-syne">SEBI Registered</h3>
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-[0.2em] mb-6">Investor Protection First</p>
          
          <div className="w-full h-px bg-slate-100 mb-6"></div>
          
          <p className="text-sm md:text-md font-medium text-slate-600 leading-relaxed italic px-4">
            "Operating within a secure, mandate-driven framework to protect and preserve capital."
          </p>
        </div>
      </div>

    </div>
  </div>
</section>


{/* SECTION 5: PMS MODELS */}

{/* 
<section className="pt-12 pb-24 bg-white relative overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    
    
    <div className="mb-20">
      <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-syne font-medium mb-6">
           PMS Service Models
         </h3>
      <div className="w-16 h-1 bg-red-600 mt-4 rounded-full"></div>
    </div>

    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {[
        {
          title: "Discretionary",
          highlight: "Manager Decides",
          desc: "Full management authority rests with the Portfolio Manager. Strategic execution is handled independently."
        },
        {
          title: "Non-Discretionary",
          highlight: "Client Approves",
          desc: "The manager proposes investment ideas, but execution occurs only after your explicit confirmation."
        },
        {
          title: "Advisory",
          highlight: "Manager Advises",
          desc: "Pure strategy and advice are provided. You retain full control over execution and direct holdings."
        }
      ].map((item, idx) => (
        <div 
          key={idx} 
          className="relative p-10 bg-slate-50 rounded-3xl border border-slate-100 hover:bg-white hover:shadow-[0_20px_50px_-12px_rgba(0,0,0,0.08)] transition-all duration-500 group"
        >
          <div className="relative z-10">
           
            <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 group-hover:text-red-600 transition-colors duration-300">
              {item.highlight}
            </h4>
            
            
            <h3 className="text-xl font-bold text-slate-900 mb-4 font-syne">
              {item.title} PMS
            </h3>
            
           
            <p className="text-sm text-slate-500 leading-relaxed font-medium group-hover:text-slate-600 transition-colors duration-300">
              {item.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
*/}



{/* SECTION 7: REGULATORY DISCLAIMER 
<section className="py-12 bg-white">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-[#434242] rounded-2xl px-10 py-12 md:px-16"
    >
      <div className="max-w-5xl mx-auto">
        
        <div className="flex items-center gap-3 mb-8 justify-center md:justify-start">
          
          <h3 className="text-white font-syne font-bold text-xs uppercase tracking-[0.4em]">
            Regulatory Disclaimer
          </h3>
        </div>

       
        <p className="text-[11px] md:text-xs text-slate-400 leading-[1.8] text-center md:text-justify font-medium">
          Investment in securities market are subject to market risks. Read all the related documents carefully before investing. 
          Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any 
          assurance of returns to investors. The performance related information is not verified by SEBI. Past performance does not 
          guarantee future results. <span className="text-white font-bold tracking-tight">DreamLadder Capital</span> is a registered Portfolio Manager under SEBI (Portfolio Managers) Regulations, 2020.
        </p>
      </div>
    </motion.div>
  </div>
</section>
*/}
{/* SECTION 8: CTA FOOTER */}
{/* SECTION 8: FINAL CTA */}
{/* SECTION 8: FINAL CTA */}



 <section
  className="py-10 md:py-14 text-center relative overflow-hidden "
  style={{
    backgroundImage: `url(${faqBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Shorter, more aggressive fade to keep the image original below the top edge */}
  <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white via-white/20 to-transparent pointer-events-none z-0"></div>
 {/* BOTTOM FADE: Very short & aggressive to remove the sharp bottom edge only */}
  <div className="absolute bottom-0 left-0 w-full h-10 bg-gradient-to-t from-white via-white/20 to-transparent pointer-events-none z-0"></div>
  <div className="relative z-10 px-6">
   
     <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> Why PMS?</h2>

    <p className="mt-4 text-base md:text-lg
 text-slate-600  font-medium max-w-2xl mx-auto">
       Ideal for high-net-worth investors seeking a customized, actively managed portfolio with long-term wealth creation potential under a regulated, transparent framework.
          </p>
  </div>
</section>



{/* ================= AIF INTRO SECTION ================= */}
<section className="relative pt-16 pb-8 overflow-hidden bg-white">
  {/* Background Decor */}
  <div className="absolute top-0 left-0 w-1/3 h-full bg-slate-50/50 -z-10 hidden lg:block" />

  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    {/* increased gap to 32 for maximum breathing room */}
    <div className="flex flex-col lg:flex-row-reverse items-center justify-between gap-12 lg:gap-32">
      
      {/* RIGHT SIDE: CONTENT */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-3/5"
      >
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight  mb-8">
          Alternative Investment Funds 
        </h3>
      
        {/* max-w-lg ensures the text block stays compact and away from the image */}
        <div className="space-y-6 max-w-lg">
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
            Alternative Investment Funds (AIF) are privately pooled investment vehicles that collect funds from investors to invest in assets beyond traditional equity and debt instruments. 
          </p>
          
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
            They are ideal for sophisticated investors seeking diversified, high-growth, and long-term strategies managed by professional fund managers.
          </p>

          <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-10 italic">
            AIFs offer a structured path to alternative asset classes with the benefit of expert management and high-conviction strategies.
          </p>
        </div>
      </motion.div>

      {/* LEFT SIDE: IMAGE */}
      <motion.div 
        className="w-full lg:w-2/5 flex justify-start"
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Kept container slightly smaller to pull it further left */}
        <div className="w-full max-w-[380px]">
          <img 
            src={aifImg} 
            alt="Alternative Investment Funds" 
            className="w-full h-auto object-cover aspect-[4/3] "
          />
        </div>
      </motion.div>

    </div>
  </div>
</section>



{/* ================= AIF CATEGORIES SECTION ================= */}


<section className="pb-4  md:pb-4 md:pt-20 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
      
      {/* LEFT SIDE: COMPACT BOXES - Reduced width to 50% */}
      <div className="w-full lg:w-[50%] order-2 lg:order-1 space-y-4">
        {[
          { 
            num: "01", 
            title: "Category I AIF", 
            desc: "Invests in early-stage ventures, startups, social ventures, or infrastructure.",
            obj: "Promote entrepreneurship and economic growth.",
            ex: "Venture Capital, Angel & Infrastructure Funds"
          },
          { 
            num: "02", 
            title: "Category II AIF", 
            desc: "Invests in equity or debt instruments not covered under Category I or III.",
            obj: "Long-term capital appreciation.",
            ex: "Private Equity & Debt Funds"
          },
          { 
            num: "03", 
            title: "Category III AIF", 
            desc: "Uses leveraged strategies to generate short- to medium-term returns.",
            obj: "Absolute return through trading and arbitrage.",
            ex: "Hedge & Long-Short Funds"
          }
        ].map((item, idx) => (
          <motion.div 
            key={idx}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1 }}
            className="group relative bg-white p-3 md:p-4 rounded-xl border border-slate-100 text-left overflow-hidden transition-all duration-500 shadow-sm hover:shadow-md hover:border-red-100"
          >
            <div className="absolute inset-0 bg-red-50/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0" />

            <div className="relative z-10">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-10 h-10 bg-red-50 group-hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors duration-300 -mt-1">
                  <span className="text-red-600 group-hover:text-white text-lg font-bold">{item.num}</span>
                </div>
                <h4 className="font-syne text-xl font-bold text-slate-900 tracking-tight">
                  {item.title} 
                </h4>
              </div>
              
              <p className="text-slate-600 text-base md:text-lg  mb-2 font-medium">
                {item.desc} 
              </p>
            
              <div className="flex flex-col md:flex-row md:items-center gap-x-8  pt-3 border-t border-slate-100/60">
                <div className="flex-1">
                  <span className="text-[12px] uppercase tracking-widest text-slate-400 font-bold block mb-0.5">Objective</span>
                  <p className="text-slate-600 text-base md:text-md leading-relaxed -mb-2 font-medium italic">"{item.obj}"</p>
                </div>
                <div className="flex-1">
                  <span className="text-[12px] uppercase tracking-widest text-slate-400 font-bold block mb-0.5">Examples</span>
                  <p className="text-slate-600 text-base md:text-md leading-relaxed -mb-2 font-medium ">{item.ex}</p>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* RIGHT SIDE: HEADING + IMAGE - Increased width to 45% */}
     <div className="w-full lg:w-[45%] order-1 lg:order-2 lg:sticky lg:top-24 ">
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    className="mb-8 -mt-16 text-center lg:text-left"
  >
    <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-4">
      Types of AIF
    </h3>
    <p className="text-slate-500 text-sm uppercase tracking-[0.3em] font-bold mb-6">
      As per SEBI Regulations, 2012
    </p>
    
    {/* NEW DESCRIPTION BLOCK */}
    <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-8 hidden lg:block">
      SEBI classifies Alternative Investment Funds into three distinct categories based on their 
      investment objectives and target asset classes. Each category serves specific investor needs, 
      ranging from social impact and infrastructure to complex trading strategies.
    </p>
  </motion.div>

  <motion.div 
    className="flex justify-center"
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
    <div className="relative w-full max-w-[550px]">
      <img 
        src={aifTypes} 
        alt="AIF Strategy" 
        className="w-full h-auto object-contain scale-110 origin-top" 
      />
    </div>
  </motion.div>
</div>
    </div>
  </div>
</section>




<section 
  className="relative  pb-24  md:pt-24 md:pb-20 overflow-hidden bg-white "
>
  {/* TOP FADE */}
  <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-white via-white/40 to-transparent pointer-events-none z-0"></div>
  
  {/* BOTTOM FADE */}
  <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-white via-white/40 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

      {/* LEFT SIDE */}
      <div className="max-w-xl">
       
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
          Regulatory Framework
        </h3>

        <div className="w-16 h-[3px] bg-red-600 mb-8"></div>

        <p className="text-slate-600 text-lg md:text-xl leading-relaxed font-medium mb-12">
          AIFs in India operate under the SEBI (Alternative Investment Funds) Regulations, 2012, ensuring a sophisticated environment for private capital.
        </p>

        <div className="relative group">
          <img 
            src={aifReg} 
            alt="SEBI Regulatory Compliance" 
            className="w-full h-auto drop-shadow-2xl rounded-2xl transform transition-transform duration-700 group-hover:scale-[1.02]"
          />
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="max-w-2xl">

        <div className="space-y-10">

          {[
            {
              title: "Mandatory SEBI Registration:",
              desc: "All AIFs must be registered with SEBI."
            },
            {
              title: "Minimum Investment Threshold:",
              desc: "To ensure sophisticated participation, a minimum ticket size of ₹1 crore is required from investors."
            },
            {
              title: "Leverage Restrictions:",
              desc: "Category I & II AIFs cannot use leverage except for temporary needs; Category III can, within limits."
            },
            {
              title: "Transparency & Disclosure:",
              desc: "Fund managers must report performance, valuation, and risks transparently."
            },
            {
              title: "Eligible Investor Profile:",
              desc: "Participation is strictly limited to High-Net-Worth Individuals (HNIs) and Institutional Investors who meet the criteria."
            }
          ].map((item, idx) => (
            <div key={idx} className="group flex gap-6">
              
              <span className="text-slate-400 font-syne font-bold text-lg mt-[2px] transition-colors duration-300 group-hover:text-red-600">
                0{idx + 1}
              </span>

              <p className="text-slate-700 text-base md:text-lg leading-relaxed font-medium transition-colors duration-300 group-hover:text-slate-900">
                <span className="font-semibold text-slate-900">
                  {item.title}
                </span>{" "}
                {item.desc}
              </p>

            </div>
          ))}

        </div>

      </div>

    </div>
  </div>
</section>

{/*
<section
  className="py-20 text-center"
  style={{
    backgroundImage: `url(${kidBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="max-w-7xl mx-auto px-6">
    
    <h3 className="font-syne text-[28px] md:text-[40px] font-medium text-slate-900 mb-4 tracking-tight">
      Invest with confidence.
    </h3>
    
    
    <p className="text-slate-600 text-lg md:text-xl mb-10 font-medium max-w-2xl mx-auto">
      Build a long-term strategy that grows with you.
    </p>

    
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
     
      <button className="w-full sm:w-auto bg-red-600 text-white px-8 py-3 rounded-lg font-semibold flex items-center justify-center hover:bg-red-700 transition-all shadow-md text-[15px]">
        Book a PMS Consultation
      </button>
      
      
      <button className="w-full sm:w-auto bg-white border-2 border-slate-200 text-slate-900 px-8 py-3 rounded-lg font-semibold flex items-center justify-center hover:bg-slate-50 transition-all shadow-sm text-[15px]">
        Speak to a Relationship Manager
      </button>
    </div>
  </div>
</section>
*/}

 <section
  className=" pt-4 md:pt-8 pb-10 md:pb-14 text-center relative overflow-hidden "
  style={{
    backgroundImage: `url(${faqBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Shorter, more aggressive fade to keep the image original below the top edge */}
  <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white via-white/20 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 px-6">
  
     <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Why AIF?</h2>

    <p className="mt-4 text-base md:text-lg text-slate-600  font-medium max-w-2xl mx-auto">
      AIFs provide access to alternative assets and strategies that can enhance portfolio diversification, improve risk-adjusted returns, and unlock growth beyond traditional markets — all under a regulated, transparent framework.
    </p>
  </div>
</section>

    </div>
  );
};

export default PMSAIF;